import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";


export const organizationUnits = async (tenantName: string) => {
    const url = `${NGROK}/api/${tenantName}/ad-organization-units`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const getUsers = async (tenantName: string) => {
    const url = `${NGROK}/api/${tenantName}/ad-users`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const registerdUsers = async (tenantName: string) => {
    const url = `${NGROK}/api/keycloak/${tenantName}/users`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const userInvites = async (tenantName: string) => {
    const url = `${NGROK}/api/invite/pending?tenantName=${tenantName}`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}


export const sendInvite = async (payload: any) => {
    const url = `${NGROK}/api/invite/send`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return data;
}

/**
 * Ad computers API call
 * @param tenantName 
 * @returns 
 */

export const getDevices = async (tenantName: string) => {
    const url = `${NGROK}/api/${tenantName}/ad-computers`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const getUserGroupMemberships = async (tenantName: string, userId: number) => {
    const url = `${NGROK}/api/${tenantName}/ad-user-groups/membership/${userId}`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const getOUUsers = async (ouId: number) => {
    const url = `${NGROK}/api/organization-units/${ouId}/ad-users`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const getOUDevices = async (ouId: number) => {
    const url = `${NGROK}/api/organization-units/${ouId}/ad-computers`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data;
}

export const updateUserGroupMembership = async (
    tenantName: string,
    payload: {
        userId: number;
        groupId: number;
        groupStatus: "ENABLED" | "DISABLED";
        selectedTime: number;
    }
) => {
    const url = `${NGROK}/api/${tenantName}/ad-user-groups/membership`;
    const data = await apiClient({
        method: "PUT",
        url,
        data: payload
    });
    return data;
}